/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following the 20-20-20 rule to reduce digital eye strain during screen work.`)
};

const es_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir la regla 20-20-20 para reducir la fatiga visual digital durante el trabajo frente a pantallas.`)
};

const de_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die 20-20-20-Regel befolgen, um digitale Augenbelastung bei Bildschirmarbeit zu reduzieren.`)
};

const nl_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 20-20-20-regel volgen om digitale oogvermoeidheid tijdens schermwerk te verminderen.`)
};

const fr_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre la règle du 20-20-20 pour réduire la fatigue oculaire numérique pendant le travail sur écran.`)
};

const it_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguire la regola del 20-20-20 per ridurre l'affaticamento oculare digitale durante il lavoro al computer.`)
};

const pt_br2_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir a regra 20-20-20 para reduzir a fadiga ocular digital durante o trabalho com telas.`)
};

const pt_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir a regra 20-20-20 para reduzir a fadiga ocular digital durante o trabalho com ecrãs.`)
};

const ja_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面作業中のデジタル眼精疲労を軽減するため、20-20-20ルールを実践する。`)
};

const zh_timer_u20m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在使用屏幕工作时遵循20-20-20法则，减轻数字眼疲劳。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_use1", locale)
	if (locale === "en") return en_timer_u20m_use1(inputs)
	if (locale === "es") return es_timer_u20m_use1(inputs)
	if (locale === "de") return de_timer_u20m_use1(inputs)
	if (locale === "nl") return nl_timer_u20m_use1(inputs)
	if (locale === "fr") return fr_timer_u20m_use1(inputs)
	if (locale === "it") return it_timer_u20m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_use1(inputs)
	if (locale === "pt") return pt_timer_u20m_use1(inputs)
	if (locale === "ja") return ja_timer_u20m_use1(inputs)
	return zh_timer_u20m_use1(inputs)
};